/**
 * Languages with non-experimental support through Google Translate, with certain non-regionalized codes omitted where
 * those languages have significant regional variation. The full current list can be found here:
 * https://cloud.google.com/translate/docs/languages
 */
export const SUPPORTED_LANGUAGES = [
  { code: 'af', label: 'Afrikaans' },
  { code: 'sq', label: 'Shqip' },
  { code: 'ar', label: 'العربية' },
  { code: 'az', label: 'Azərbaycan' },
  { code: 'be', label: 'Беларуская' },
  { code: 'bn', label: 'বাংলা' },
  { code: 'bs-Cyrl', label: 'Босански' },
  { code: 'bs', label: 'Bosanski' },
  { code: 'bg', label: 'Български' },
  { code: 'my', label: 'မြန်မာ' },
  { code: 'ca', label: 'Català' },
  { code: 'zh-CN', label: '中文 (中国)' },
  { code: 'zh-HK', label: '中文 (香港)' },
  { code: 'zh-Hans', label: '简体中文' },
  { code: 'zh-TW', label: '中文 (台灣)' },
  { code: 'zh-Hant', label: '繁體中文' },
  { code: 'zh', label: '中文' },
  { code: 'hr', label: 'Hrvatski' },
  { code: 'cs', label: 'Čeština' },
  { code: 'da', label: 'Dansk' },
  { code: 'nl-BE', label: 'Nederlands (België)' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'en-AU', label: 'English (Australia)' },
  { code: 'en-CA', label: 'English (Canada)' },
  { code: 'en-NZ', label: 'English (NZ)' },
  { code: 'en-PH', label: 'English (Philippines)' },
  { code: 'en-ZA', label: 'English (SA)' },
  { code: 'en-GB', label: 'English (UK)' },
  // TODO(will): This broader code is mapped to `en-US` until a migration can be made across the platform.
  { code: 'en', label: 'English (US)' },
  { code: 'et', label: 'Eesti' },
  { code: 'fil', label: 'Filipino' },
  { code: 'fi', label: 'Suomi' },
  { code: 'fr-CA', label: 'Français (Canada)' },
  { code: 'fr-CH', label: 'Français (Suisse)' },
  { code: 'fr', label: 'Français' },
  { code: 'fy', label: 'Frysk' },
  { code: 'gl', label: 'Galego' },
  { code: 'ka', label: 'ქართული' },
  { code: 'de', label: 'Deutsch' },
  { code: 'el', label: 'Ελληνικά' },
  { code: 'gn', label: "Avañe'ẽ" },
  { code: 'gu', label: 'ગુજરાતી' },
  { code: 'he', label: 'עברית' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'hu', label: 'Magyar' },
  { code: 'is', label: 'Íslenska' },
  { code: 'id', label: 'Bahasa Indonesia' },
  { code: 'it', label: 'Italiano' },
  { code: 'ja', label: '日本語' },
  { code: 'kn', label: 'ಕನ್ನಡ' },
  { code: 'km', label: 'ខ្មែរ' },
  { code: 'ko', label: '한국어' },
  { code: 'ky', label: 'Кыргызча' },
  { code: 'lo', label: 'ລາວ' },
  { code: 'lv', label: 'Latviešu' },
  { code: 'ln', label: 'Lingála' },
  { code: 'lt', label: 'Lietuvių' },
  { code: 'mk', label: 'Македонски' },
  { code: 'ms', label: 'Bahasa Melayu' },
  { code: 'ml', label: 'മലയാളം' },
  { code: 'mr', label: 'मराठी' },
  { code: 'ne', label: 'नेपाली' },
  { code: 'nb', label: 'Norsk Bokmål' },
  { code: 'no', label: 'Norsk' },
  { code: 'fa', label: 'فارسی' },
  { code: 'pl', label: 'Polski' },
  { code: 'pt-BR', label: 'Português (Brasil)' },
  { code: 'pt-PT', label: 'Português (Portugal)' },
  { code: 'pa-PK', label: 'پنجابی' },
  { code: 'pa', label: 'ਪੰਜਾਬੀ' },
  { code: 'ro', label: 'Română' },
  { code: 'ru', label: 'Русский' },
  { code: 'sk', label: 'Slovenčina' },
  { code: 'sl', label: 'Slovenščina' },
  { code: 'es-AR', label: 'Español (Argentina)' },
  { code: 'es-CL', label: 'Español (Chile)' },
  { code: 'es-CO', label: 'Español (Colombia)' },
  { code: 'es-CR', label: 'Español (Costa Rica)' },
  { code: 'es-EC', label: 'Español (Ecuador)' },
  { code: 'es-SV', label: 'Español (El Salvador)' },
  { code: 'es-GT', label: 'Español (Guatemala)' },
  { code: 'es-HT', label: 'Español (Haití)' },
  { code: 'es-HN', label: 'Español (Honduras)' },
  { code: 'es-419', label: 'Español (Latinoamérica)' },
  { code: 'es-MX', label: 'Español (México)' },
  { code: 'es-NI', label: 'Español (Nicaragua)' },
  { code: 'es-PA', label: 'Español (Panamá)' },
  { code: 'es-PY', label: 'Español (Paraguay)' },
  { code: 'es-PE', label: 'Español (Perú)' },
  { code: 'es-PR', label: 'Español (Puerto Rico)' },
  { code: 'es-ES', label: 'Español (España)' },
  { code: 'es-US', label: 'Español (Estados Unidos)' },
  { code: 'es-UY', label: 'Español (Uruguay)' },
  { code: 'es-VE', label: 'Español (Venezuela)' },
  { code: 'sw', label: 'Kiswahili' },
  { code: 'sv', label: 'Svenska' },
  { code: 'tl', label: 'Tagalog' },
  { code: 'ta', label: 'தமிழ்' },
  { code: 'te', label: 'తెలుగు' },
  { code: 'th', label: 'ไทย' },
  { code: 'tr', label: 'Türkçe' },
  { code: 'uk', label: 'Українська' },
  { code: 'ur', label: 'اردو' },
  { code: 'uz', label: 'Oʻzbekcha' },
  { code: 'vi', label: 'Tiếng Việt' },
  { code: 'cy', label: 'Cymraeg' },
  { code: 'zu', label: 'isiZulu' },
] as const;

type Language = (typeof SUPPORTED_LANGUAGES)[number];

export const DEFAULT_LANGUAGE: Language = SUPPORTED_LANGUAGES.find(({ code }) => code === 'en')!;

export const LANGUAGE_FALLBACKS = {
  'en-US': DEFAULT_LANGUAGE,
  es: SUPPORTED_LANGUAGES.find(({ code }) => code === 'es-419')!,
  pt: SUPPORTED_LANGUAGES.find(({ code }) => code === 'pt-BR')!,
};

/**
 * These are legacy language codes which may still apply to some users. This constant should be used for resolving
 * labels, but the UI should only allow users to select from `SUPPORTED_LANGUAGES`.
 */
export const LABELED_LANGUAGES = [
  ...SUPPORTED_LANGUAGES,
  { code: 'en-US', label: 'English (US)' },
  { code: 'es', label: 'Spanish' },
  { code: 'pt', label: 'Português' },
] as const;

export type LanguageCode = Language['code'];
export const SUPPORTED_LANGUAGE_CODES = SUPPORTED_LANGUAGES.map((l) => l.code);

export const DEFAULT_NS = 'glade';

/** Returns true for any English language variant (en, en-US, en-GB, en-AU, etc.). Content is already in English for these, so no translation is needed. */
export const isEnglishVariant = (code: string): boolean => code.toLowerCase().startsWith('en');
